import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Navigation
    nav_home: 'Home',
    nav_product: 'Product',
    nav_how_it_works: 'How It Works',
    nav_company: 'Company',
    nav_contact: 'Contact',
    nav_login: 'Login',
    nav_dashboard: 'Dashboard',
    nav_logout: 'Logout',
    
    // Hero
    hero_title: 'SMART IRRIGATION',
    hero_subtitle: 'FOR EVERY FARM',
    hero_description: 'Control your irrigation remotely. Works anywhere with mobile signal. Reliable for farm use.',
    hero_cta: 'GET STARTED',
    hero_learn_more: 'LEARN MORE',
    
    // Features
    features_title: 'FEATURES',
    feature_remote: 'Remote Control',
    feature_remote_desc: 'Open or close valves from anywhere using your phone',
    feature_schedule: 'Smart Scheduling',
    feature_schedule_desc: 'Set irrigation times and let the system handle the rest',
    feature_pressure: 'Pressure Control',
    feature_pressure_desc: 'Adjust water pressure for optimal irrigation',
    feature_monitor: 'Real-time Monitoring',
    feature_monitor_desc: 'Track device status and receive instant alerts',
    
    // Product
    product_title: 'FAC SMART VALVE',
    product_subtitle: 'Built for Farmers',
    product_benefit_1: 'Works with 4G/LTE signal',
    product_benefit_2: 'Weather resistant design',
    product_benefit_3: 'Easy installation',
    product_benefit_4: '2-year warranty',
    
    // How It Works
    how_title: 'HOW IT WORKS',
    how_step_1: 'Install',
    how_step_1_desc: 'Connect the smart valve to your irrigation system',
    how_step_2: 'Connect',
    how_step_2_desc: 'Add your device using the serial number in the app',
    how_step_3: 'Control',
    how_step_3_desc: 'Manage your irrigation from anywhere',
    
    // Company
    company_title: 'FAC SOLUTIONS',
    company_mission: 'Mission',
    company_mission_text: 'Help farmers manage water easily with smart technology',
    company_vision: 'Vision',
    company_vision_text: 'Smart irrigation available to every farm',
    
    // Contact
    contact_title: 'CONTACT US',
    contact_name: 'Name',
    contact_email: 'Email',
    contact_message: 'Message',
    contact_send: 'SEND MESSAGE',
    contact_success: 'Message sent successfully!',
    
    // Auth
    login_title: 'LOGIN',
    login_email: 'Email',
    login_password: 'Password',
    login_submit: 'LOGIN',
    login_register: "Don't have an account? Register",
    register_title: 'REGISTER',
    register_name: 'Full Name',
    register_submit: 'CREATE ACCOUNT',
    register_login: 'Already have an account? Login',
    
    // Dashboard
    dashboard_title: 'MY DEVICES',
    dashboard_add_device: 'ADD DEVICE',
    dashboard_no_devices: 'No devices yet. Add your first smart valve!',
    device_online: 'Online',
    device_offline: 'Offline',
    device_last_seen: 'Last seen',
    device_pressure: 'Pressure',
    
    // Device Control
    control_title: 'DEVICE CONTROL',
    control_valve: 'Valve Control',
    control_open: 'OPEN',
    control_close: 'CLOSE',
    control_pressure: 'Pressure Setting',
    control_schedule: 'Irrigation Schedule',
    control_add_schedule: 'Add Schedule',
    control_start_time: 'Start Time',
    control_duration: 'Duration (minutes)',
    control_repeat: 'Repeat',
    control_once: 'Once',
    control_daily: 'Daily',
    control_weekly: 'Weekly',
    
    // Logs
    logs_title: 'ACTIVITY LOGS',
    logs_filter: 'Filter by date',
    logs_export: 'Export CSV',
    logs_empty: 'No activity logs yet',
    
    // Alerts
    alerts_title: 'ALERTS',
    alerts_empty: 'No alerts',
    alert_device_offline: 'Device went offline',
    alert_power_loss: 'Power loss detected',
    alert_pressure_high: 'Water pressure too high',
    alert_pressure_low: 'Water pressure too low',
    alert_valve_error: 'Valve not responding',
    
    // Admin
    admin_title: 'ADMIN PANEL',
    admin_users: 'Users',
    admin_devices: 'All Devices',
    admin_logs: 'System Logs',
    admin_assign: 'Assign',
    admin_lock: 'Lock',
    admin_unlock: 'Unlock',
    
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    confirm: 'Confirm',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    bar: 'bar',
    minutes: 'min',
    
    // Weather
    weather_title: 'Weather',
  },
  zh: {
    // Navigation
    nav_home: '首頁',
    nav_product: '產品',
    nav_how_it_works: '運作方式',
    nav_company: '公司',
    nav_contact: '聯絡我們',
    nav_login: '登入',
    nav_dashboard: '控制台',
    nav_logout: '登出',
    
    // Hero
    hero_title: '智慧灌溉',
    hero_subtitle: '為每個農場',
    hero_description: '遠端控制灌溉系統。只要有行動訊號，隨時隨地都能使用。專為農業設計，穩定可靠。',
    hero_cta: '立即開始',
    hero_learn_more: '了解更多',
    
    // Features
    features_title: '功能特色',
    feature_remote: '遠端控制',
    feature_remote_desc: '使用手機隨時隨地開關閥門',
    feature_schedule: '智慧排程',
    feature_schedule_desc: '設定灌溉時間，讓系統自動執行',
    feature_pressure: '壓力控制',
    feature_pressure_desc: '調整水壓以達到最佳灌溉效果',
    feature_monitor: '即時監控',
    feature_monitor_desc: '追蹤設備狀態並接收即時警報',
    
    // Product
    product_title: 'FAC 智慧閥門',
    product_subtitle: '專為農民打造',
    product_benefit_1: '支援 4G/LTE 訊號',
    product_benefit_2: '防水防塵設計',
    product_benefit_3: '安裝簡便',
    product_benefit_4: '兩年保固',
    
    // How It Works
    how_title: '運作方式',
    how_step_1: '安裝',
    how_step_1_desc: '將智慧閥門連接到您的灌溉系統',
    how_step_2: '連接',
    how_step_2_desc: '在應用程式中輸入設備序號進行配對',
    how_step_3: '控制',
    how_step_3_desc: '隨時隨地管理您的灌溉系統',
    
    // Company
    company_title: 'FAC 智慧方案',
    company_mission: '使命',
    company_mission_text: '以智慧科技幫助農民輕鬆管理用水',
    company_vision: '願景',
    company_vision_text: '讓每個農場都能享受智慧灌溉',
    
    // Contact
    contact_title: '聯絡我們',
    contact_name: '姓名',
    contact_email: '電子郵件',
    contact_message: '訊息',
    contact_send: '發送訊息',
    contact_success: '訊息已成功發送！',
    
    // Auth
    login_title: '登入',
    login_email: '電子郵件',
    login_password: '密碼',
    login_submit: '登入',
    login_register: '還沒有帳號？註冊',
    register_title: '註冊',
    register_name: '姓名',
    register_submit: '建立帳號',
    register_login: '已有帳號？登入',
    
    // Dashboard
    dashboard_title: '我的設備',
    dashboard_add_device: '新增設備',
    dashboard_no_devices: '尚無設備。新增您的第一個智慧閥門！',
    device_online: '在線',
    device_offline: '離線',
    device_last_seen: '最後更新',
    device_pressure: '水壓',
    
    // Device Control
    control_title: '設備控制',
    control_valve: '閥門控制',
    control_open: '開啟',
    control_close: '關閉',
    control_pressure: '壓力設定',
    control_schedule: '灌溉排程',
    control_add_schedule: '新增排程',
    control_start_time: '開始時間',
    control_duration: '持續時間（分鐘）',
    control_repeat: '重複',
    control_once: '單次',
    control_daily: '每日',
    control_weekly: '每週',
    
    // Logs
    logs_title: '活動紀錄',
    logs_filter: '依日期篩選',
    logs_export: '匯出 CSV',
    logs_empty: '尚無活動紀錄',
    
    // Alerts
    alerts_title: '警報',
    alerts_empty: '沒有警報',
    alert_device_offline: '設備已離線',
    alert_power_loss: '偵測到電源中斷',
    alert_pressure_high: '水壓過高',
    alert_pressure_low: '水壓過低',
    alert_valve_error: '閥門無回應',
    
    // Admin
    admin_title: '管理面板',
    admin_users: '使用者',
    admin_devices: '所有設備',
    admin_logs: '系統日誌',
    admin_assign: '指派',
    admin_lock: '鎖定',
    admin_unlock: '解鎖',
    
    // Common
    save: '儲存',
    cancel: '取消',
    delete: '刪除',
    confirm: '確認',
    loading: '載入中...',
    error: '錯誤',
    success: '成功',
    warning: '警告',
    bar: 'bar',
    minutes: '分鐘',
    
    // Weather
    weather_title: '天氣',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('fac-language');
    return saved || 'zh';
  });

  useEffect(() => {
    localStorage.setItem('fac-language', language);
    document.documentElement.lang = language === 'zh' ? 'zh-TW' : 'en';
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'zh' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
